import './Phone';

if (typeof window.MaskApplicator === 'undefined') {
    window.MaskApplicator = class MaskApplicator {
        constructor(container) {
            this.types = {
                phone: window.Phone,
            };

            this.apply(container || document);
        }

        apply(container) {
            const fields = container.querySelectorAll('[data-mask]');
            for (const input of fields) {
                if (input.dataset.maskApplied === '1') {
                    continue;
                }

                new this.types[input.dataset.mask](input);
                input.dataset.maskApplied = '1';
            }
        }
    };
}
